// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F9qX","newExpiryDate":"styles_newExpiryDate__1lHUZ","footer":"styles_footer__2RYma"};